<script>
import { Line } from 'vue-chartjs'

export default Line.extend({
  mounted () {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [
        {
          label: 'Data One',
          backgroundColor: '#f87979',
          data: [40, 39, 10, 40, 39, 80, 40]
        }
      ]
    }, {responsive: true, maintainAspectRatio: false})
  }
})
</script>



// WEBPACK FOOTER //
// src/views/charts/LineExample.vue?5010aed0